export const useUtil = () => {
    const isValidDate = (date: Date): boolean => !isNaN(date.getTime());

    const FormatDate = (dateInput: string | Date | undefined): string => {
        if (!dateInput) return "Fecha no disponible";
    
        const date = new Date(dateInput);
        if (!isValidDate(date)) {
            console.warn("⚠️ Fecha inválida en FormatDate:", dateInput);
            return "Fecha inválida";
        }
    
        return date.toLocaleDateString("es-ES", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
        });
        };
    
        const FormatDateAMD = (dateInput: string | Date | undefined): string => {
        if (!dateInput) return "0000-00-00";
    
        const date = new Date(dateInput);
        if (!isValidDate(date)) {
            console.warn("⚠️ Fecha inválida en FormatDateAMD:", dateInput);
            return "0000-00-00";
        }
    
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };

    return {
        FormatDate,
        FormatDateAMD,
    };
};  